import React from "react";
import { Route, Routes, Navigate } from "react-router";
import { RequiredPermission } from '../authentication/RequiredPermission';

import {
    Encuestas
} from '../pages/Encuestas/Encuestas';
import { EncuestasVotar } from "../pages/Encuestas/EncuestasVotar";
import { Resultados } from "../pages/Encuestas/EncuestaResultados";
import { EncuestaNueva } from "../pages/Encuestas/EncuestaNueva";

export const RutasEncuestas = () => {

    return(
        <Routes>
            <Route path="/encuestas" element={<Encuestas />} />
            <Route path="/encuestas/votar/:encuestaId" element={<EncuestasVotar />} />

            <Route element={<RequiredPermission permission={['ROLE_VER_RESULTADOS_ENCUESTA']} />}>
                <Route path="/encuestas/resultados/:encuestaId" element={<Resultados />} />
            </Route>

            <Route path="/crearencuesta" element={<EncuestaNueva />} />

            <Route path='/*' element={<Navigate to="/" replace />} />
        </Routes>
    );

};